<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="Ip地址" name="opIp">
                <a-input v-model:value="searchForm.opIp" placeholder="请输入Ip地址"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
        </a-table>
    </a-card>
<!--    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>-->
</template>
<script>
import {tableListMixin} from "@/mixins";
// import AddOrEditModal from "./AddOrEditModal";
import {vislogApi} from "@/api/innovationService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "日志名称", dataIndex: "name", key: "name"},
    {title: "IP地址", dataIndex: "opIp", key: "opIp"},
    {title: "地址", dataIndex: "opAddress", key: "opAddress"},
    {title: "浏览器", dataIndex: "opBrowser", key: "opBrowser"},
    {title: "设备", dataIndex: "opOs", key: "opOs"},
    {title: "时间", dataIndex: "createdTime", key: "createdTime"},
    {title: "用户", dataIndex: "createdBy", key: "createdBy"},
    // {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    props:{visitId:String},
    components: {
        // AddOrEditModal,
    },
    data() {
        return {
            columns,
            queryParamFixed: {category:"LOGIN",createdBy:this.$ls.get("userInfo")},
            listUrl: vislogApi.pageList,
            listKeyField: "id",
            userInfoName:""
        }
    },

    watch:{
        visitId(val){
            if(val == 1){
                this.loadData(1)
            }
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="less">
</style>
